import { getCitiesForGuide } from "../data/service-guides";
import { InternalLinkRow } from "./internal-links";

/**
 * Pushes guide readers into the localized city cluster for the guide's topic.
 */
export function GuideCityLinks({
  guideSlug,
  guideTitle,
}: {
  guideSlug: string;
  guideTitle?: string;
}) {
  const cities = getCitiesForGuide(guideSlug, 8);
  if (cities.length === 0) return null;
  void guideTitle;
  return (
    <InternalLinkRow
      tone="white"
      eyebrow="Serving The Capital Region"
      title="Get It Done In Your Town"
      links={cities.map((c) => ({
        href: `/${c.slug}`,
        label: `${c.service} in ${c.city}, NY`,
      }))}
    />
  );
}
